<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>
    <scroller class="scroller-menu" :maxWidth="1150" :offset="20" ref="scroller">
      <button-filter-menu
        class="button-menu-format filter-buttons"
        v-for="filter in filtersArray"
        :key="filter.label"
        :label="filter.label"
        :iconClass="getImageClass"
        :filter="filter.value.value"
        :class="{disabled: !filter.enabled || !isImage}"
        :locked="filter.locked"
        @click.native="onSelectFilter(filter)"
        :data-filter="true"
      />
    </scroller>
    <slider
      ref="slider"
      :config="sliderType"
      v-if="showSlider"
      @close="showSlider=false"
      @input="updateSliderValue"
      @change="onChange"
    />
  </div>
</template>
<script>
import { ColorEffect } from '@/model/pixel/customfilter/ColorEffect'

import menu from './menu-default'
import ButtonFilterMenu from '@/components/buttons/ButtonFilterMenu'
import Scroller from '@/components/scroller/Scroller'
import Slider from '@/components/slider/Slider'

import { EventBus, PAYMENT_INFO } from '@/model/EventBus'
import { defined, getFirst, not } from 'junctions-fp'
import { mapGetters } from 'vuex'
export default {
  name: 'FiltresMenu',
  mixins: [menu],
  components: {
    ButtonFilterMenu,
    Scroller,
    Slider
  },
  beforeCreate() {},
  created() {
    this.editor.on('selectedObject', object => {
      this.onSelectedObject(object)
    })
  },
  beforeMount() {},
  mounted() {
    this.onSelectedObject(this.editor.getCurrentSelectedObject())
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null,
      currentImage: '',

      filtersArray: [
        {
          label: 'Aucun filtre',
          value: { type: 'none' },
          enabled: true,
          locked: false
        },
        {
          label: 'Noir & Blanc',
          value: { type: 'color', value: 'GrayScale' },
          enabled: true,
          locked: false
        },
        {
          label: 'Sepia',
          value: { type: 'color', value: 'Sep' },
          enabled: true,
          locked: false
        },
        {
          label: 'Polaroid',
          value: { type: 'color', value: 'Polaroid' },
          enabled: true,
          locked: false
        },
        {
          label: 'Vintage',
          value: { type: 'color', value: 'Vintage' },
          enabled: true,
          locked: false
        },
        {
          label: 'Pinker',
          value: { type: 'color', value: 'Pinker' },
          enabled: true,
          locked: false
        },
        {
          label: 'NewYork',
          value: { type: 'color', value: 'NewYork' },
          enabled: true,
          locked: false
        },
        {
          label: 'Dallas',
          value: { type: 'color', value: 'Dallas' },
          enabled: true,
          locked: false
        },
        {
          label: 'NewDallas',
          value: { type: 'color', value: 'NewDallas' },
          enabled: true,
          locked: false
        },
        {
          label: 'Umbrella',
          value: { type: 'color', value: 'Umbrella' },
          enabled: true,
          locked: false
        },
        {
          label: 'Oldies',
          value: { type: 'color', value: 'Oldies' },
          enabled: true,
          locked: false
        },
        {
          label: 'Legend',
          value: { type: 'color', value: 'Legend' },
          enabled: true,
          locked: false
        }
      ],
      showSlider: false,
      sliderType: {
        icon: 'sprite-small-filter',
        label: 'valeur',
        min: 0,
        max: 100,
        type: 'percent',
        value: 100
      },
      currentFilter: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getLimitations']),
    getImageClass() {
      return `background-image:url(${this.currentImage});`
    }
  },
  methods: {
    onSelectedObject(item) {
      this.filtersArray = this.filtersArray.map((item, index) => {
        if (getFirst(this.getLimitations.filters) !== -1) {
          if (!this.getLimitations.filters.includes(index)) {
            item.locked = true
          }
        }
        return item
      })
      const enabled = defined(item) && item.type === 'image'
      if (enabled) {
        this.currentImage = item._originalElement.src
      }
      this.filtersArray = this.filtersArray.map(u => {
        u.enabled = enabled
        return u
      })
    },
    onSelectFilter(f) {
      if (f.locked) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        return
      }
      let filter = null
      if (f.value.type !== 'none') {
        filter = new ColorEffect({ color: f.value.value, factor: this.getCurrentFilterValue() })
        this.sliderType.value = this.getCurrentFilterValue() * 100
        if (this.showSlider === false) {
          this.showSlider = true
          window.addEventListener('click', this.hideSlider)
        }
        this.currentFilter = f.value.value
      } else {
        this.showSlider = false
        window.removeEventListener('click', this.hideSlider)
      }

      this.editor.addFilter(filter, 4, true)
      this.templateModified()
    },
    hideSlider(event) {
      if (this.$refs.slider && !this.$refs.slider.$el.contains(event.target) && not(defined(event.target.dataset.filter))) {
        this.showSlider = false
        window.removeEventListener('click', this.hideSlider)
      }
    },
    updateSliderValue(value) {
      const factor = value.value / 100
      this.editor.addFilter(new ColorEffect({ color: this.currentFilter, factor }), 4)
    },
    onChange(value) {
      const factor = value.value / 100
      this.editor.addFilter(new ColorEffect({ color: this.currentFilter, factor }), 4, true)
    },
    getCurrentFilterValue() {
      const current = this.editor.getCurrentSelectedObject()
      if (current && current.type === 'image') {
        return current.filters[4] ? current.filters[4].factor : 1
      }
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/FiltresMenu.vue